import { FC } from "react";
import { TTradeDocument } from "../../types/trades/trades";
import DocumentPreview from "../commons/document-preview";
import { Images } from "../../types/loans/partners/partners";

const DocumentsComponent: FC<{
  title: string;
  documents: Array<TTradeDocument> | Images[];
  className?: string;
}> = ({ title, documents, className }) => (
  <div className={`${className}`}>
    <div className="fs-12 color-sub-text mb-1">{title}</div>

    {documents?.length > 0 ? (
      <div className="flex gap-2 overflow-x-auto overflow-y-hidden">
        {documents?.map((doc, i) => (
          <div className="shrink-0 br-10 border doc_card relative">
            <a href={doc.url} target="_blank">
              <DocumentPreview
                url={doc.url}
                docType={
                  doc.url?.toLowerCase().includes(".pdf") ? "pdf" : "image"
                }
              />
            </a>
          </div>
        ))}
      </div>
    ) : (
      <div
        className=" flex justify-center items-center bg-gray-light br-10 p-[10px] doc_card text-center cursor-pointer "
        style={{
          border: "1px dashed #595959",
        }}
      >
        <span className="fs-12"> No Document Uploaded</span>
      </div>
    )}
  </div>
);

export default DocumentsComponent;
